import {BaseEndpoint} from "../../../../base/endpoints/base.endpoint";
import {environment} from "../../../../../environments/environment";
import {IParams} from "../../../../base/endpoints/iparams";

export class AccountingEndpoint extends BaseEndpoint {
  static LEADERBOARDS = {
    FETCH_LEADERBOARD(username: string): string {
      return environment.base_url + '/api/v1/leaderboards/' + username + '/leaderboard'
    },
    REDEEM(): string {
      return environment.base_url + '/api/v1/redeems'
    },
    FETCH_RECENT_ACHIEVEMENTS(params: IParams) {
      return environment.base_url + '/api/v1/public/latest-achievements'
        + BaseEndpoint.toParamString(params)
    }
  }

  static WALLET = {
    FETCH_MY_WALLET(params: IParams): string {
      return environment.base_url + '/api/v1/my-wallet' + BaseEndpoint.toParamString(params)
    },

    FETCH_USER_WALLET(params: IParams): string {
      return environment.base_url + '/api/v1/admin/wallets/user-wallet' + BaseEndpoint.toParamString(params)
    },
    FETCH_TRANSACTIONS(params: IParams): string {
      return environment.base_url + '/api/v2/admin/transactions' + BaseEndpoint.toParamString(params)
    }

  }

  static TRANSACTION_CATEGORIES = {
    TRANSACTION_CATEGORY_ENDPOINT: environment.base_url + '/api/v2/tnx-categories',
    TRANSACTION_CATEGORY_ENDPOINT_ADMIN: environment.base_url + '/api/v2/admin/tnx-categories',
    SEARCH(endpoint: string, params: IParams) {
      return endpoint.concat(BaseEndpoint.toParamString(params));
    },
    CREATE(endpoint: string): string {
      return endpoint
    },
    GET(endpoint: string, id: number): string {
      return endpoint + '/' + id
    },
    UPDATE(endpoint: string, id: number): string {
      return endpoint + '/' + id
    },
  }
}
